import React from 'react';

const TwitterFeeds = () => {
  return <div>Twitter Feeds</div>;
};

export default TwitterFeeds;
